export enum WATCH_MODE {
  ON_CHANGE = 'ON_CHANGE',
  ON_BLUR = 'ON_BLUR',
}
